export default __webpack_public_path__ + "static/media/icon-cloud.62c35a7d.svg";